export default "__VITE_ASSET__DTg9Crkq__"